import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import type { Species } from '@/features/fieldSlice';
import { capitalize } from '@/helpers/stringConversion';
import type { FilterState } from '@/features/filterSlice';

const getSpeciesOptions = (data: Species[]) =>
  data.map((s: Species) => ({
    value: `${s.id}`,
    label: capitalize(s.name),
  }));

export const SpeciesFilter = (props: {
  control: Control<FilterState>;
  data: Species[];
}) => {
  const intl = useClientTerminology();
  const speciesOptions = getSpeciesOptions(props.data);
  return (
    <Controller
      control={props.control}
      name="species"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label={intl.formatMessage({
              id: 'filter.treeSpeciesLabel',
            })}
            placeholder={intl.formatMessage({
              id: 'filter.treeSpeciesPlaceholder',
            })}
            options={speciesOptions}
            onChange={onChange}
            onBlur={onBlur}
            value={speciesOptions.filter((c) => value.includes(c.value))}
            maxMenuHeight={150}
          />
        );
      }}
    />
  );
};
